import { xingFaviconUrl } from '@xing-com/xing-logo';

export const getFaviconUrl = (isPreview?: boolean): string =>
  isPreview ? 'data:,' : xingFaviconUrl;
